import React from 'react';
import { useAtom } from 'jotai';

import { ledgerDialogAtom } from '../../store/ledger/ledger-dialog';
import { LedgerConnectDialog } from '../Dialog/LedgerDialog/LedgerConnectDialog';
import { LedgerSignMessageDialog } from '../Dialog/LedgerDialog/LedgerSignMessageDialog';
import { LedgerSignTransactionDialog } from '../Dialog/LedgerDialog/LedgerSignTransactionDialog';

export const GlobalDialogs: React.FC = () => {
  const [ledgerDialog, setLedgerDialog] = useAtom(ledgerDialogAtom);

  return (
    <>
      {ledgerDialog?.isConnectOpened && (
        <LedgerConnectDialog
          open={ledgerDialog?.isConnectOpened || false}
          onClose={() => setLedgerDialog({})}
        />
      )}
      {ledgerDialog?.isSignTxOpened && (
        <LedgerSignTransactionDialog
          unsignedTx={ledgerDialog.unsignedTx || ''}
          onSuccess={(signedTx) => {
            ledgerDialog.onSignSuccess && ledgerDialog.onSignSuccess(signedTx);
            setLedgerDialog({});
          }}
          open={ledgerDialog.isSignTxOpened || false}
          onClose={() => setLedgerDialog({})}
        />
      )}
      {ledgerDialog?.isSignMessageOpened && (
        <LedgerSignMessageDialog
          message={ledgerDialog.message || ''}
          onSuccess={(signature) => {
            ledgerDialog.onSignSuccess && ledgerDialog.onSignSuccess(signature);
            setLedgerDialog({});
          }}
          open={ledgerDialog.isSignMessageOpened || false}
          onClose={() => setLedgerDialog({})}
        />
      )}
    </>
  );
};
